module.exports = __webpack_public_path__ + "img/5.dc0be681.png";